// extracted by mini-css-extract-plugin
export default {"content":"style_content__-OdZd","search":"style_search__eijOS"};